<template>
    <div v-if="user.merchant">
        <form id="update_merchant_form">
            <kt-row>
                <kt-col xs="12" sm="6">
                    <kt-form-group>
                        <kt-form-label for="birth_crtfct_number">
                            {{ $t('label.birth_crtfct_number') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr"  v-model="user.merchant.birth_crtfct_number" name="birth_crtfct_number"
                                         id="birth_crtfct_number"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6">
                    <kt-form-group>
                        <kt-form-label for="national_code">
                            {{ $t('label.national_code') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr"  v-model="user.merchant.national_code" name="national_code"
                                         id="national_code"></kt-form-control>
                    </kt-form-group>
                </kt-col>


                <kt-col xs="12" sm="6">
                    <kt-form-group>
                        <kt-form-label for="gender">
                            {{ $t('label.gender') }}
                        </kt-form-label>
                        <kt-form-select
                                id="gender_id"
                                name="gender_id"
                                v-model="user.merchant.gender"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-for="gender in genderTypes" :value="gender" v-bind:key="gender">
                                {{ genderTypesStr.get(gender) }}
                            </option>
                        </kt-form-select>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6">
                    <kt-form-group>
                        <kt-form-label for="birth_date">
                            {{ $t('label.birth_date') }}
                        </kt-form-label>
                        <datePicker
                                format="YYYY-MM-DD HH:mm:ss"
                                display-format="jDD jMMMM jYYYY"
                                input-class="form-control"
                                id="register_date"
                                name="register_date"
                                v-model="user.merchant.birth_date" type="date"/>
                    </kt-form-group>
                </kt-col>


                <kt-col xs="12" sm="6">
                    <kt-form-group>
                        <kt-form-label for="first_name_fa">
                            {{ $t('label.first_name_fa') }}
                        </kt-form-label>
                        <kt-form-control
                                v-model="user.merchant.first_name_fa" name="first_name_fa"
                                         id="first_name_fa"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6">
                    <kt-form-group>
                        <kt-form-label for="first_name_en">
                            {{ $t('label.first_name_en') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr"  v-model="user.merchant.first_name_en" name="first_name_en"
                                         id="first_name_en"></kt-form-control>
                    </kt-form-group>
                </kt-col>


                <kt-col xs="12" sm="6">
                    <kt-form-group>
                        <kt-form-label for="last_name_fa">
                            {{ $t('label.last_name_fa') }}
                        </kt-form-label>
                        <kt-form-control  v-model="user.merchant.last_name_fa" name="last_name_fa"
                                         id="last_name_fa"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6">
                    <kt-form-group>
                        <kt-form-label for="last_name_en">
                            {{ $t('label.last_name_en') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr"  v-model="user.merchant.last_name_en" name="last_name_en"
                                         id="last_name_en"></kt-form-control>
                    </kt-form-group>
                </kt-col>


                <kt-col xs="12" sm="6">
                    <kt-form-group>
                        <kt-form-label for="father_name_fa">
                            {{ $t('label.father_name_fa') }}
                        </kt-form-label>
                        <kt-form-control  v-model="user.merchant.father_name_fa" name="father_name_fa"
                                         id="father_name_fa"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6">
                    <kt-form-group>
                        <kt-form-label for="father_name_en">
                            {{ $t('label.father_name_en') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr" v-model="user.merchant.father_name_en" name="father_name_en"
                                         id="father_name_en"></kt-form-control>
                    </kt-form-group>
                </kt-col>


                <kt-col xs="12" sm="4">
                    <kt-form-group>
                        <kt-form-label for="birth_crtfct_series_letter">
                            {{ $t('label.birth_crtfct_series_letter') }}
                        </kt-form-label>
                        <kt-form-select
                                id="birth_crtfct_series_letter"
                                name="birth_crtfct_series_letter"
                                v-model="user.merchant.birth_crtfct_series_letter"
                                class="form-control kt-selectpicker"
                        >
                            <option
                                    v-for="serries_letter in birthCrtfctSeriesLetters" :value="serries_letter.key"
                                    v-bind:key="serries_letter.key">
                                {{ serries_letter.value }}
                            </option>
                        </kt-form-select>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="4">
                    <kt-form-group>
                        <kt-form-label for="birth_crtfct_series_number">
                            {{ $t('label.birth_crtfct_series_number') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr"  v-model="user.merchant.birth_crtfct_series_number"
                                         name="birth_crtfct_series_number"
                                         id="birth_crtfct_series_number"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="4">
                    <kt-form-group>
                        <kt-form-label for="birth_crtfct_serial">
                            {{ $t('label.birth_crtfct_serial') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr"  v-model="user.merchant.birth_crtfct_serial" name="birth_crtfct_serial"
                                         id="birth_crtfct_serial"></kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col xs="12" sm="6">
                    <kt-form-group>
                        <kt-form-label for="cellphone_number">
                            {{ $t('label.phone') }}
                        </kt-form-label>
                        <kt-form-control dir="ltr"  v-model="user.merchant.cellphone_number" name="cellphone_number"
                                         id="cellphone_number"></kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-form-action class="mt-4">
                <kt-button
                        class="m-2 btn-wide"
                        size="md"
                        variant="success"
                        type="button"
                        v-bind:wide="true"
                        id="update_merchant_btn"
                        @click="updateMerchant"
                >
                    {{ $t('btn.submit_changes') }}
                </kt-button>
            </kt-form-action>
        </form>
        <kt-row>
            <kt-col v-if="user.merchant.requests.length > 0">
                <kt-table is_responsive>
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>{{ $t('label.status') }}</th>
                        <th>{{ $t('label.type') }}</th>
                        <th>{{ $t('label.response_thacking_number') }}</th>
                        <th>{{ $t('label.response_success') }}</th>
                        <th>{{ $t('label.response_rejection_reason') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-bind:key="index" v-for="(request, index) in user.merchant.requests">
                        <td>{{ request.id }}</td>
                        <td>{{ shRequestStatusStr.get(request.status) }}</td>
                        <!-- <td>{{ shRequestTypeStr.get(request.type) }}</td> -->
                        <td>{{ request.type }}</td>
                        <td>{{ request.response_tracking_number }}</td>
                        <td>{{ shSuccessRequest(request.response_success) }}</td>
                        <td v-bind:key="rindex"
                            v-for="(rejection, rindex) in request.response_rejection_reason">
                            <span>{{ rejection.codeExceptionValue }} : {{ rejection.fieldName }}</span>
                        </td>
                        <td v-if="request.response_rejection_reason.length == 0"></td>
                    </tr>
                    </tbody>
                </kt-table>
            </kt-col>
            <kt-col v-else class="mb-4">
                <p class="badge badge-warning w-100 p-3 text-dark" style="font-size:1.2em">
                    {{ $t('not_sent_request_to_shaparak_yet') }}
                </p>
            </kt-col>
        </kt-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {shRequestStatusStr} from '@/constants/shaparakRequestStatus'
import {shRequestTypeStr} from '@/constants/shaparakRequestType'
import {genderTypes, genderTypesStr} from '@/constants/genderTypes'
import {birthCrtfctSeriesLetters} from '@/constants/birthCrtfctSeriesLetter'
import $ from "jquery";
import {i18n} from '@/plugins/i18n';
import {userService} from '@/common/api.service';
import {KTApp} from '@/plugins/core/app';
import toastr from "toastr";
import Form from "../../ivr/components/form";

export default {
    computed: {
        ...mapGetters('user', [
            'user'
        ]),
        shRequestStatusStr() {
            return shRequestStatusStr
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    },
    data() {
        return {
            genderTypes,
            genderTypesStr,
            birthCrtfctSeriesLetters
        }
    },
    methods: {
        shSuccessRequest(response_success) {
            return response_success == 1 ? this.$t('label.yes') : this.$t('label.no')
        },
        createMerchantRequest(e) {
        },
        updateMerchant() {
            let form = $('#update_merchant_form')
            let btn = $('#update_merchant_btn')
            form.validate({
                ignore: ":hidden",

                rules: {
                    birth_crtfct_number: {
                        required: true,
                    },
                    national_code: {
                        required: true,
                    },
                    gender: {
                        required: true,
                    },
                    birth_date: {
                        required: true,
                    },
                    first_name_fa: {
                        required: true,
                    },
                    first_name_en: {
                        required: true,
                    },
                    last_name_fa: {
                        required: true,
                    },
                    last_name_en: {
                        required: true,
                    },
                    father_name_fa: {
                        required: true,
                    },
                    father_name_en: {
                        required: true
                    },
                    birth_crtfct_series_letter: {
                        required: true
                    },
                    birth_crtfct_series_number: {
                        required: true
                    },
                    birth_crtfct_serial: {
                        required: true
                    },
                    cellphone_number: {
                        required: true
                    },
                },
            });
            if (!form.valid()) {
                return
            }
            let has_regex_error = false;

            if (!this.checkIfIsPersian(this.user.merchant.first_name_fa)) {
                form.validate().showErrors({
                    first_name_fa: i18n.t('pos.validations.enter_persian')
                })
                has_regex_error = true;
            }    if (!this.checkIfIsPersian(this.user.merchant.last_name_fa)) {
                form.validate().showErrors({
                    last_name_fa: i18n.t('pos.validations.enter_persian')
                })
                has_regex_error = true;
            }
            if (!this.checkIfIsPersian(this.user.merchant.father_name_fa)) {
                form.validate().showErrors({
                    father_name_fa: i18n.t('pos.validations.enter_persian')
                })
                has_regex_error = true;
            }
            if (!this.checkIfIsEnglish(this.user.merchant.first_name_en)) {
                form.validate().showErrors({
                    first_name_en: i18n.t('pos.validations.enter_english')
                })
                has_regex_error = true;
            }    if (!this.checkIfIsEnglish(this.user.merchant.last_name_en)) {
                form.validate().showErrors({
                    last_name_en: i18n.t('pos.validations.enter_english')
                })
                has_regex_error = true;
            }
            if (!this.checkIfIsEnglish(this.user.merchant.father_name_en)) {
                form.validate().showErrors({
                    father_name_en: i18n.t('pos.validations.enter_english')
                })
                has_regex_error = true;
            }
            if (has_regex_error) return;
            KTApp.progress(btn)

            userService.updateMerchant(this.user.merchant.id, this.user.merchant).then(response => {
                return this.toastr.success(response.data.message)
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)

            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        checkIfIsPersian(value) {
            if (!value || value=='null') return true;

            let regex = /^[\u0600-\u06FF\s]+$/;

           return regex.test(value)
        },
        checkIfIsEnglish(value) {
            if (!value || value =='null') return true;

            let regex = /^[a-zA-Z0-9?><;,{}[\]\-_+=!@#$%\^&*| ']*$/;

            return regex.test(value)
        },
    },
    mounted() {

    }
}
</script>

<style>
</style>